import styled from 'styled-components';

export const InputText = styled.textarea`
    width: 100%;
    height: 100%;
    font-size: 14px;
    border: none;
    outline: none;
    resize: none;
`